exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-6f87f1de]{margin:40px 0 0}ul[data-v-6f87f1de]{list-style-type:none;padding:0}li[data-v-6f87f1de]{display:inline-block;margin:0 10px}a[data-v-6f87f1de]{color:#42b983}", ""]);

// exports
